// React Router Dom
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';

//components
import WCSAddCluster from './WCSAddCluster';
import WCSDecisionMaker from './WCSDecisionMaker';
// import CreateNewClusterForm from './CreateNewClusterForm';
import ClustersList from './ClustersList';
import Spinner from '../../components/console/Spinner';

const WCSRoutes = ({ clusters }) => {
  return (
    <Router>
      <Switch>
        <Route path='/console/wcs/spinner' render={() => <Spinner />} />
        <Route
          path='/console/wcs/add-cluster'
          render={() => <WCSAddCluster />}
        />
        {/* <Route
          path="/console/wcs/add-cluster-form"
          render={() => <CreateNewClusterForm clusters={clusters} />}
        /> */}
        <Route path='/console/wcs/clusters' render={() => <ClustersList />} />
        <Route
          exact
          path='/console/wcs'
          render={() => <WCSDecisionMaker clusters={clusters} />}
        />
      </Switch>
    </Router>
  );
};

export default WCSRoutes;
